import { get } from "lodash"
import { createSelector } from "reselect"
import { ReduxState } from "model/state"
import { getRole } from "helpers/permissions/roles"
import { Role } from "model/state"

const getAccountStatus = (state: ReduxState): string | undefined =>
  get(state, "global.selected.accountMeta.status")

const getIsSuperuser = (state: ReduxState): boolean =>
  get(state, "user.isSuperuser", false)

const getGenericSolutionsCount = (state: ReduxState): number | undefined =>
  get(state, "global.data.solutionsCount.data.generic")

const getSigmaSolutionsCount = (state: ReduxState): number | undefined =>
  get(state, "global.data.solutionsCount.data.sigma")

const getGenericSolutionsAvailable = createSelector(
  [getGenericSolutionsCount, getRole, getIsSuperuser],
  (genericSolutionsCount: number | undefined, role: Role, isSuperuser: boolean): boolean => {
    if (!genericSolutionsCount) {
      return false
    }
    if (!isSuperuser && role !== "admin") {
      return false
    }
    return true
  },
)

export const getIsSuperuserSession = createSelector(
  [getIsSuperuser, getAccountStatus],
  (isSuperuser: boolean, accountStatus: string | undefined): boolean =>
    isSuperuser && accountStatus !== "internal",
)

export const getHasSolutions = createSelector(
  [getGenericSolutionsAvailable, getSigmaSolutionsCount],
  (genericSolutionsAvailable: boolean, sigmaSolutionsCount: number | undefined): boolean => {
    if (genericSolutionsAvailable || !!sigmaSolutionsCount) {
      return true
    }
    return false
  },
)
